export default __webpack_public_path__ + "static/media/cholet17.0e6b8b5c.jpg";